import { Component, OnInit } from '@angular/core';
import { Producto } from '../../../../model/class/Producto';
import { Archivo } from '../../../../model/class/Archivo';
import { Categoria } from '../../../../model/class/Categoria';
import { CategoriaProducto } from '../../../../model/class/CategoriaProducto';
import { PreviewFantasyCategoryService } from '../../../services/preview-fantasy-category/preview-fantasy-category.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-preview-categoria-especial',
  templateUrl: './preview-categoria-especial.component.html',
  styleUrls: ['./preview-categoria-especial.component.css']
})
export class PreviewCategoriaEspecialComponent implements OnInit {

  tipo = {
    productos: 'bag-productos',
    banners: 'bag-banners',
    catalogo: 'bag-catalogo',
    galeria: 'bag-galeria',
    imgVerticales: 'bag-img-verticales',
    imgHorizontales: 'bag-img-horizontales',
  };

  categoria: Categoria;
  bannersSeleccionados: Archivo[] = [];
  imgGaleriaSeleccioandas: Archivo[] = [];
  elementos: any[] = [];

  ordenProductos = 'destacados';

  constructor(
    private previewFantasyCategoryService: PreviewFantasyCategoryService
  ) {
    this.categoria = this.previewFantasyCategoryService.categoria;
    this.elementos = this.previewFantasyCategoryService.elementos;
    this.bannersSeleccionados = this.previewFantasyCategoryService.bannersSeleccionados;
    this.imgGaleriaSeleccioandas = _.cloneDeep(this.previewFantasyCategoryService.imgGaleriaSeleccioandas);
    for (const file of this.imgGaleriaSeleccioandas) {
      if (file.nuevo) {
        file.url = file.previewUrl;
      }
    }
  }

  ngOnInit() {
  }

  ordenarProductos(ordern?: string) {}

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/preview-categoria-especial/preview-categoria-especial.component.ts